<template>
  <v-container fluid class="mx-3 mt-3 mb-1">
    <div class="d-flex justify-start mb-3">
      <v-btn-toggle v-model="period" mandatory dense color="#2b58e2">
        <v-btn v-for="option in periods" :key="option" :value="option" small>
          {{ $t(`dashboard.header.periods.${option}`) }}
        </v-btn>
      </v-btn-toggle>
    </div>
    <div class="header-grid">
      <v-card
        v-for="card in cards"
        :key="card.key"
        class="header-card"
        :class="{ clickable: card.link, 'header-card--current': card.current }"
        elevation="0"
        @click="goToHistory(card.link)"
      >
        <div class="header-card__content">
          <p class="header-card__title">
            {{ $t(`dashboard.header.${card.key}`) }}
          </p>
          <p class="header-card__value font-weight-bold">
            {{ card.value }}
          </p>
          <span class="header-card__caption">
            {{
              card.current
                ? $t("dashboard.header.current")
                : $t(`dashboard.header.periodCaptions.${period}`)
            }}
          </span>
        </div>
        <div
          class="header-card__icon"
          :style="{ color: card.color, backgroundColor: `${card.color}1f` }"
        >
          <v-icon :color="card.color" large>
            {{ card.icon }}
          </v-icon>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "DashboardHeader",
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      periods: ["last_24h", "last_7d", "last_30d", "all"],
      period: "last_7d",
    };
  },
  computed: {
    cards() {
      const { claims = {}, intake = {} } = this.details.activity_totals || {};
      return [
        {
          key: "intakePending",
          value: this.details.summary.intake.pending,
          current: true,
          link: 1,
          icon: "mdi-clock-outline",
          color: "#f0a500",
        },
        {
          key: "intakeApproved",
          counts: intake.Approved,
          icon: "mdi-check-circle-outline",
          color: "#399652",
        },
        {
          key: "intakeRejected",
          counts: intake.Rejected,
          link: 2,
          icon: "mdi-close-circle-outline",
          color: "#DD5555",
        },
        {
          key: "claimOpen",
          counts: claims.Open,
          link: 4,
          icon: "mdi-folder-open-outline",
          color: "#2b58e2",
        },
        {
          key: "claimClosed",
          counts: claims.Closed,
          icon: "mdi-archive-check-outline",
          color: "#433c3c",
        },
      ].map(({ counts, ...card }) => ({
        ...card,
        value: card.value ?? counts?.[this.period] ?? 0,
      }));
    },
  },
  methods: {
    goToHistory(status) {
      if (!status) return;
      this.$router.push({ name: "History", query: { status } });
    },
  },
};
</script>

<style scoped>
.header-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.header-card {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 24px;
  color: #433c3c;
  cursor: default;
}

.header-card.clickable {
  cursor: pointer;
}

.header-card__content {
  flex: 1;
  min-width: 0;
}

.header-card__title {
  font-size: 16px;
  margin-bottom: 4px;
}

.header-card--current {
  background-color: #fff6e0 !important;
}

.header-card__value {
  font-size: 34px;
  line-height: 1.1;
  margin: 8px 0 4px;
}

.header-card__caption {
  display: block;
  font-size: 13px;
  color: #a09d9d;
}

.header-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 50% !important;
}

@media (min-width: 600px) {
  .header-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .header-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .header-card__title {
    font-size: 18px;
  }
  .header-card__value {
    font-size: 40px;
  }
}

@media (min-width: 1264px) {
  .header-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (min-width: 1904px) {
  .header-card__value {
    font-size: 48px;
  }
}
</style>
